import {
  FaAward,
  FaLightbulb,
  FaUsers,
  FaRocket,
} from "react-icons/fa";

// Single source of truth for the "Why Choose Us" section and the
// /why-choose-us/:slug detail page.
export const reasons = [
  {
    slug: "proven-delivery",
    title: "Proven Delivery Excellence",
    Icon: FaAward,
    description:
      "Successfully delivering complex projects, programmes, and transformation initiatives from strategy through implementation.",
    overview:
      "Delivery is where strategy becomes reality. Our track record spans complex projects and large-scale programmes across regulated industries — delivered on time, within budget, and aligned to measurable business outcomes.",
    highlights: [
      "Disciplined governance & delivery frameworks",
      "On-time, on-budget project execution",
      "Agile, Waterfall & hybrid methodologies",
      "Risk-managed, quality-assured delivery",
      "Transparent stakeholder reporting",
      "Outcomes measured against business value",
    ],
  },
  {
    slug: "industry-expertise",
    title: "Industry Expertise",
    Icon: FaLightbulb,
    description:
      "Extensive experience across Banking, Payments, Social Housing, Education, Retail, and Non-Profit sectors.",
    overview:
      "We bring deep, sector-specific knowledge to every engagement. Understanding the regulations, challenges, and customers unique to each industry means we deliver solutions that fit your context — not generic templates.",
    highlights: [
      "Banking & financial services",
      "Payments & open banking",
      "Social housing & public sector",
      "Education & learning technology",
      "Retail & eCommerce",
      "Non-profit & membership organizations",
    ],
  },
  {
    slug: "client-centric",
    title: "Client-Centric Approach",
    Icon: FaUsers,
    description:
      "Building trusted partnerships, understanding business objectives, and delivering measurable outcomes.",
    overview:
      "We work as an extension of your team. By taking the time to understand your objectives and constraints, we build long-term, trusted partnerships focused on delivering real, measurable value — not just deliverables.",
    highlights: [
      "Deep discovery & objective alignment",
      "Collaborative, transparent working",
      "Tailored solutions, not templates",
      "Long-term partnership mindset",
      "Clear communication at every stage",
      "Success measured by your outcomes",
    ],
  },
  {
    slug: "technology-innovation",
    title: "Technology & Innovation",
    Icon: FaRocket,
    description:
      "Leveraging Salesforce, MuleSoft, Oracle Fusion, Boomi, and cloud technologies to accelerate growth.",
    overview:
      "We combine leading enterprise platforms with a pragmatic approach to innovation. From CRM and integration to cloud and automation, we harness the right technology to accelerate your growth and modernize your operations.",
    highlights: [
      "Salesforce CRM & platform expertise",
      "MuleSoft & Boomi integration",
      "Oracle Fusion ERP transformation",
      "Cloud & API-led architecture",
      "Automation & digital innovation",
      "Scalable, future-ready solutions",
    ],
  },
];

export const getReason = (slug) => reasons.find((r) => r.slug === slug);
